<template>
	<Col>
		<v-menu
			rounded="lg"
			v-model="showMenu"
			origin="center bottom"
			transition="slide-y-transition"
			:close-on-content-click="false"
			:nudge-right="nudgeRight || 40"
			:nudge-bottom="nudgeBottom || 35"
			content-class="select-favorite-apps-menu"
		>
			<template v-slot:activator="{ on, attrs, value }">
				<div v-on="on" v-bind="attrs">
					<slot v-bind:value="value" name="activator" />
				</div>
			</template>
			<Col class="menu-content overflow-y-auto height-100 pt-5 pb-2 px-3">
				<Row class="flex-align-center mb-1 pl-5">
					<h5 class="accordion-title">{{ title }}</h5>
					<component :class="titleSuffixComponent.class" :is="titleSuffixComponent.component" v-if="titleSuffixComponent?.component" />
				</Row>
				<NavigationAccordionContent
					:to="to"
					:sections="sections"
					:settings="settings"
					@item-clicked="showMenu = false"
					:additionalItemSuffix="additionalItemSuffix"
				/>
			</Col>
		</v-menu>
	</Col>
</template>
<script>
import NavigationAccordionContent from './NavigationAccordionContent';
export default {
	name: 'CollapsedNavigationAccordionMenu',
	components: { NavigationAccordionContent },
	props: {
		to: { type: Function },
		title: { type: String },
		sections: { type: Array },
		settings: { type: Object },
		nudgeRight: { type: Number },
		nudgeBottom: { type: Number },
		additionalItemSuffix: { type: Object },
		titleSuffixComponent: { type: Object, default: () => ({}) },
	},
	data() {
		return { showMenu: false };
	},
};
</script>
<style lang="scss" scoped>
.accordion-title {
	font-weight: 600;
}
.menu-content {
	width: 290px;
	max-height: 400px;
	border-radius: 6px;
	background: #ffffff;
	border: 1px solid #dfdfe2;
	box-shadow: 0px 3px 6px #00000029;
}
</style>
